import { render } from "./projectdetails.vue?vue&type=template&id=6da90b30"
import script from "./projectdetails.vue?vue&type=script&lang=js"
export * from "./projectdetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__